import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';

const propTypes = {
	...SectionProps.types
}

const defaultProps = {
	...SectionProps.defaults
}

const Hero = ({
	className,
	topOuterDivider,
	bottomOuterDivider,
	topDivider,
	bottomDivider,
	hasBgColor,
	invertColor,
	...props
}) => {

	const outerClasses = classNames(
		'hero section center-content',
		topOuterDivider && 'has-top-divider',
		bottomOuterDivider && 'has-bottom-divider',
		hasBgColor && 'has-bg-color',
		invertColor && 'invert-color',
		className
	);

	const innerClasses = classNames(
		'hero-inner section-inner',
		topDivider && 'has-top-divider',
		bottomDivider && 'has-bottom-divider'
	);

	return (
		<section
			{...props}
			className={outerClasses}
		>
			<div className="container-sm">
				<div className={innerClasses}>
					<div className="hero-content">
						<h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
							Satergo wallet for <span className="text-color-primary">Ergo</span>
						</h1>
						<div className="container-xs">
							<p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
								The desktop wallet for the Ergo cryptocurrency, with embedded node functionality.
							</p>
							<div className="reveal-from-bottom" data-reveal-delay="600">
								<ButtonGroup>
									<Button tag="a" color="primary" wideMobile href="https://t.me/Satergo">
										Telegram
										</Button>
									<Button tag="a" color="dark" wideMobile href="https://github.com/Satergo/Satergo">
										Source code
										</Button>
										<Button tag="a" color="dark" wideMobile href="https://github.com/Satergo/satergo.com/blob/master/CHANGELOG.md#readme">
										Changelog
										</Button>
								</ButtonGroup>
							</div>
						</div>
					</div>
				 
				</div>
			</div>
		</section>
	);
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;